<template>
  <div class="myTree-container">
    <!-- <el-form-item :error="tips"> -->
    <el-tree
      ref="myTree"
      :show-checkbox="showCheckbox"
      :data="orgTreeData"
      :props="defaultProps"
      :filter-node-method="filterNode"
      node-key="id"
      highlight-current
      class="filter-tree"
      @node-click="handleNodeClick"
      @check-change="handleCheckChange"
    >
      <span slot-scope="{ node, data }" class="custom-tree-node">
        <span :title="node.label">
          <i v-if="data.level !== 5" class="el-icon-menu" />
          <i v-else class="el-icon-school" />
          {{ node.label }}
        </span>
      </span>
    </el-tree>
  </div>
</template>

<script>

import { getOrgTree } from '@/api/systemMaintenance/devicManage/common';
export default {
  name: 'MyTree',
  props: {
    onlySchool: {
      type: Boolean,
      default: false
    },
    showCheckbox: {
      type: Boolean,
      default: false
    },
    filterText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      orgTreeData: [],
      defaultProps: {
        children: 'childOrgList',
        label: 'name'
      },
      lastSchool: '' // 最后点击的学校节点
    };
  },
  computed: {
    currentOrg() {
      return this.$store.getters.currentOrg;
    },
    currentClickOrg() {
      return this.$store.getters.currentClickOrg;
    }
  },
  watch: {
    filterText(val) {
      this.$refs.myTree.filter(val);
    },
    currentOrg(val) {
      if (Object.keys(val).length > 0) {
        this.fetchOrgTree();
      }
    }
  },
  mounted() {
    this.fetchOrgTree();
  },
  methods: {
    // 筛选树节点
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    // 树点击事件
    handleNodeClick(data, node, el) {
      if (this.onlySchool) {
        if (data.level !== 5) {
          // 如果不是学校则取消选中状态
          node.isCurrent = false;
          // 学校依旧选中
          this.$nextTick(() => {
            this.$refs.myTree &&
              this.$refs.myTree.setCurrentKey(this.lastSchool);
          });
        } else {
          // 如果是学校则记录下来
          this.lastSchool = data;
          this.$emit('treeNodeClick', data, false);
        }
      } else {
        this.$emit('treeNodeClick', data, false);
      }
    },
    handleCheckChange(data, checked, indeterminate) {
      this.$emit('handleCheckChange', data, checked, indeterminate);
    },

    // 根据机构code获取机构树
    fetchOrgTree() {
      const manageOrgs = this.currentOrg;
      let manageOrgStr = '';
      manageOrgStr = manageOrgs.orgCode;
      getOrgTree(manageOrgStr)
        .then(res => {
          this.orgTreeData = res.data;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style scoped lang="scss">
.myTree-container {
  width: 260px;
  margin: 0 auto;
  .filter-tree {
    margin-top: 20px;
    // padding-left: 10px;
    font-size: 15px;
    .custom-tree-node {
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}
@media (max-width: 1366px) {
  .myTree-container {
    width: 200px;
  }
}
</style>
